import { Injectable } from '@angular/core';
import {
    ResourceAction,
    ResourceCRUD,
    ResourceMethod,
    ResourceParams
} from 'ng2-resource-rest';
import { RequestMethod } from '@angular/http';
import { DatetimeString } from './types';

interface IQueryInput {
    page?: number;
}

export interface IInvoice {
    id          : number;
    type        : string;
    amount      : number;
    firstname   : string;
    lastname    : string;
    address     : string;
    zipCode     : string;
    postOffice  : string;
    rows        : IOrderRow[];
    status      : number;
    reference?  : string;
    paid?       : DatetimeString;
    html?       : string;
    hash?       : string;
    vatPc       : number;
}

export interface IOrderRow {
    id: number;
    name: string;
    price : number;
}

export interface IOrderShort {
    id: number;
    rows: IOrderRow[];
    invoices : IInvoice[];
    total : number;
    fullTotal?: number;
}

export interface IOrder extends IOrderShort {
}

@Injectable()
@ResourceParams({
    url: '/api/payment'
})
export class Payment extends ResourceCRUD<IQueryInput, IOrderShort, IOrder> {

    @ResourceAction({
        path: '/send-invoice',
        method: RequestMethod.Post,
    })
    public sendInvoice: ResourceMethod<IInvoice, any>;
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader??ref--7-0!./src/app/model/payment.ts